import { createContext, useContext } from 'react'

type FullscreenContextType = {
  fullscreen: boolean
  setFullscreen: (value: boolean) => void
}

export const FullscreenContext = createContext<FullscreenContextType>({
  fullscreen: false,
  setFullscreen: () => {},
})

export const useFullscreen = () => {
  const context = useContext(FullscreenContext)

  return context
}
